import { getCookie } from '../../utils/cookies';
import logger from '../../services/logging/logging-service';
import { removeElementDom } from '../../utils/dom-utils';
import { HOROSCOPE_COOKIE_NAME, isPublishMode } from '../../utils/aem-utils';

export const init = () => {
  const horoscopeWidgetContainer = document.querySelector('.j-horoscope-section.c-horoscope-section--horoscope');
  const preferredSign = getCookie(HOROSCOPE_COOKIE_NAME);

  if (horoscopeWidgetContainer && preferredSign) {
    const path = `${horoscopeWidgetContainer.dataset.path}.${preferredSign}`;
    const preferredSignUrl = isPublishMode() ? path : `${path}.html`;

    fetch(preferredSignUrl, {
      method: 'GET',
    })
      .then((res) => res.text())
      .then((data) => {
        horoscopeWidgetContainer.classList.add('c-horoscope-section--favourite-sign');
        horoscopeWidgetContainer.innerHTML = data;

        const preferredSignIcon = document.querySelector(`.c-horoscope-signs-grid .icon--${preferredSign}`);

        if (preferredSignIcon && preferredSignIcon.parentNode) {
          removeElementDom(preferredSignIcon.parentNode);
        }
      })
      .catch((error) => {
        logger.error(`There has been a problem with your fetch operation: ${error.message}`);
      });
  }
};
